export default {
  order: {
    title: "订单分析",
    orderStats: "订单统计",
    orderCount: "订单数",
    orderTotalAmount: "订单总金额",
    validOrderCount: "有效订单数",
    totalAmount: "订单总金额",
    cancelRightsOrders: "取消/维权订单",
    shopPushCount: "商家推单数量",
    validOrders: "有效订单",
    cancelRights: "取消维权",
    shopPush: "商家推单",
    overview: "订单概况",
    pendingAccept: "待接单",
    pendingPickup: "待取货",
    pendingDelivery: "待送达",
    completed: "已完成",
    cancelOrder: "取消订单",
    afterSales: "售后/维权订单",
    riderBoard: "骑士看板",
    rankingBoard: "排行看板",
    merchantPushTop10: "商户推单量TOP10",
    riderAcceptTop10: "骑士接单量TOP10",
    riderAcceptCount: "骑士接单人数",
    totalRiderCount: "总骑手数",
    yesterdayFullDay: "昨日全天",
    yesterday: "昨日",
    rank: "排名",
    merchantName: "商户名称",
    pushCount: "推单数量",
    orderAmount: "订单总额",
    riderName: "骑手姓名",
    acceptCount: "接单量",
    commission: "所得佣金",
    totalDistance: "总旅程",
    top10: "TOP10排行",
    chartOrderCount: "订单数",
    chartOrderAmount: "订单总金额",
    chartRiderAccept: "骑手接单人数",
    chartTotalRider: "总骑手数",
    chartStackTotal: "总量",
    tipValidOrders: "统计时间内，未取消且未发生退款的订单量",
    tipTotalAmount: "统计周期内，订单金额和商户充值金额的总和",
    tipCancelRights: "统计周期内，未处理的取消/维权订单",
    tipShopPush: "统计周期内，商家推单数量",
    tipPendingAccept: "统计周期内，商家推单骑手待接单的数量",
    tipPendingPickup: "统计周期内，骑手已取货待送达的订单",
    tipPendingDelivery: "统计周期内，骑手已接单待配送的订单",
    tipCompleted: "统计周期内，骑手已送达完成的订单",
    tipCancelOrder: "统计周期内，骑手取消的订单",
    tipAfterSales: "统计周期内，未处理的售后/维权订单",
    tipRiderAccept: "统计周期内，当天已接单的骑手数量",
    tipTotalRider: "统计周期内，已认证的骑手数量",
    tipMerchantTop10: "统计周期内，商户推单数量排行",
    tipRiderTop10: "统计周期内，骑手接单数量排行",
  },
  rider: {
    title: "骑手分析",
    pendingReview: "待审核",
    pendingReviewCount: "待审核骑手(人)",
    accepted: "已接单",
    acceptedRiderCount: "已接单骑手(人)",
    totalRider: "总骑手",
    totalRiderCount: "总骑手数(人)",
    totalRegistered: "总注册",
    totalRegisterCount: "总注册数(人)",
    onlineStats: "在线骑手统计",
    date: "日期",
    onlineRiderCount: "在线骑手数",
    orderCount: "订单数",
    chartNewRider: "新增总骑手数",
    chartNewRegister: "新增总注册数",
    chartStackTotal: "总量",
  },
};
